import cx from 'classnames';
import React, { useCallback, useEffect, useRef } from 'react';
import { Typography } from '../typography';
import { getElementPosition } from './base-control/base-control.util';
import styles from './segment-control.module.scss';
export const SegmentedControlItem = ({ title, iconUrl, label, index, onSelect, isSelected, disabled, tooltip, children, classNames, isTitleBolded = false, badgeConfig, isThemeEnabled = false, tooltipPosition = 'bottom', ...restProps }) => {
    var _a;
    const itemRef = useRef(null);
    const initialItemStyle = cx((classNames === null || classNames === void 0 ? void 0 : classNames.segmentedItem) || styles.segmentedItem, isSelected && ((classNames === null || classNames === void 0 ? void 0 : classNames.selected) || styles.selected), iconUrl && ((classNames === null || classNames === void 0 ? void 0 : classNames.isIcon) || styles.isIcon), disabled && ((classNames === null || classNames === void 0 ? void 0 : classNames.disabled) || styles.disabled));
    const tooltipProps = iconUrl || children || tooltip
        ? {
            'data-tooltip-content': tooltip,
            'data-tooltip-position': tooltipPosition,
        }
        : {};
    const onSelectHandler = useCallback((target) => {
        const position = getElementPosition(target);
        onSelect(index, position);
    }, [index, onSelect]);
    useEffect(() => {
        if (isSelected && !disabled && itemRef.current) {
            onSelectHandler(itemRef.current);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSelected]);
    useEffect(() => {
        var _a;
        // checking for clientWidth makes sure the handler is called
        // only after the component is fully rendered
        if (isSelected && !disabled && ((_a = itemRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth)) {
            onSelectHandler(itemRef.current);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [(_a = itemRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth]);
    const onClickHandler = (event) => {
        if (!disabled) {
            onSelectHandler(event.target);
        }
    };
    const renderTitle = useCallback(() => {
        return isTitleBolded ? React.createElement("b", null, title) : title;
    }, [isTitleBolded, title]);
    const renderContent = useCallback(() => {
        if (children) {
            return children;
        }
        if (iconUrl) {
            return React.createElement("img", { className: styles.innerIcon, src: iconUrl, alt: "" });
        }
        if (title) {
            return (React.createElement(Typography, { variant: "body-normal", className: cx(styles.innerText, {
                    [styles.themeInnerText]: isThemeEnabled,
                }), overrideTag: "span" }, renderTitle()));
        }
        return null;
    }, [children, iconUrl, title, isThemeEnabled, renderTitle]);
    return (React.createElement("button", { type: "button", role: "tab" // role assigned as tab for screen readers
        , className: initialItemStyle, onClick: onClickHandler, ...tooltipProps, ...restProps, ref: itemRef, "aria-selected": isSelected },
        renderContent(),
        (badgeConfig === null || badgeConfig === void 0 ? void 0 : badgeConfig.isVisible) && (React.createElement("div", { className: cx(styles.facetBadgeContainer, badgeConfig.facetBadgeContainerClassName), "data-testid": "facet-badge-container" }, badgeConfig.badgeElement))));
};
//# sourceMappingURL=segment-control-item.js.map